export default "__VITE_PUBLIC_ASSET__3da5618d__"